// extracted by mini-css-extract-plugin
module.exports = {"pop-up":"pop-up--1_21_","popUp":"pop-up--1_21_","visible":"visible--2EEXp"};